import Vue from 'vue'
import axios from 'axios';
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import wechat from 'weixin-js-sdk';


Vue.use(Router)

const router = new Router({
  mode: "history",
  // base: process.env.BASE_URL,
  routes: [
    //重定向
    {
      path: "/",
      redirect: "/index",
      meta: {
        title: '哆咪商城'
      }
    },
    //哆咪商城
    {
      path: "/index",
      name: "index",
      component: () => import('@/views/index/index.vue'),
      meta: {
        title: '哆咪商城'
      }
    },
     //哆咪预约
     {
      path: "/appointment",
      name: "appointment",
      component: () => import('@/views/appointment/appointment.vue'),
      meta: {
        title: '哆咪预约'
      }
    },
    {
      path: "/microstation",
      name: "microstation",
      component: () => import('@/views/microstation/microstation.vue'),
      meta: {
        title: '微站元素'
      }
    },
    {
      path: "/about",
      name: "about",
      component: () => import('@/views/about/about.vue'),
      meta: {
        title: '关于哆咪'
      }
    },
    //重定向
    {
      path: '*',
      redirect: '/',
      meta: {
        title: '首页'
      }
    },
  ]
})

function onBridgeReadyHide() {
  WeixinJSBridge.call('hideOptionMenu');
}
function onBridgeReadyShow() {
  WeixinJSBridge.call('showOptionMenu');
}
//路由开始跳转进度条结束
router.beforeEach((to, from, next) => {
  NProgress.start()
  window.scrollTo(0,0)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

//路由跳转完毕进度条消失
router.afterEach(() => {
  NProgress.done()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js